const state = {};

const getters = {};

const actions = {
  async getForm(context, formId) {
    return await context.getters.CxmApiClient.ProcessRequest(
      "GET",
      `/api/form/${formId}`
    ).catch(err => err.response);
  },
  async saveForm(context, form) {
    return await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      "/api/form/save",
      form
    ).catch(err => err.response);
  },
  async uploadFormImage(context, request) {
    return await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      `/api/form/image/add/${request.formId}`,
      request.image
    ).catch(err => err.response);
  },
  async deleteFormImage(context, request) {
    return await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      `/api/form/image/remove`,
      request
    ).catch(err => err.response);
  },
  async uploadPdfFile(context, request) {
    return await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      `/api/form/image/from_pdf/${request.formId}`,
      request.fileData
    ).catch(err => err.response);
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/forms/FormWizard.js